import React from "react";

export function EmptyHeaderCell() {
	return <th className="empty-header-cell">&nbsp;</th>;
}
